import { HttpResponse, http } from 'msw';

import { environment } from '../../environments/environment';

const env = { ...environment };
const envServiceUrl = env.services.auth.url;

const base64Url = (value: object) =>
  btoa(JSON.stringify(value)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

const buildAccessToken = () => {
  const header = { alg: 'none', typ: 'JWT' };
  const payload = {
    user_info: {
      userNo: 'U000001',
      userID: 'qa.msw',
      userName: 'qa.msw',
      userCode: 'QA001',
      firstName: 'QA',
      lastName: null,
      localFirstName: 'QA',
      localLastName: 'Local',
      email: 'qa.msw@local.dev',
      mobileNo: '0800000000',
      roles: ['QA'],
      forceChangePassword: false,
      profileImageName: null,
      merchantName: null,
      merchantNo: null
    },
    tenant_info: {
      merchant: 'TD',
      sites: [],
      groups: [],
      stores: []
    },
    user_name: 'qa.msw',
    scope: ['ALL'],
    exp: Math.floor(Date.now() / 1000) + 8 * 60 * 60,
    jti: 'qa-msw-jti',
    authorities: ['ur_annouce_m', 'ur_annouce_v'],
    client_id: 'ADMIN_PORTAL'
  };

  return `${base64Url(header)}.${base64Url(payload)}.mock-signature`;
};

const tokenResolver = () =>
  HttpResponse.json({
    access_token: buildAccessToken(),
    refresh_token: buildAccessToken(),
    token_type: 'bearer',
    expires_in: 28800,
    scope: 'ALL'
  });

export const handlers = [http.post(env.serverUrl + envServiceUrl, tokenResolver)];
